import { useState } from 'react'

interface ConsoleLoginProps {
  onSubmit: (password: string) => void
  submitting: boolean
  error: string | null
}

/** The console's password prompt. Nothing to do with guest invite codes. */
export function ConsoleLogin({ onSubmit, submitting, error }: ConsoleLoginProps) {
  const [password, setPassword] = useState('')

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    if (submitting || password === '') return
    onSubmit(password)
  }

  return (
    <main className="flex min-h-dvh items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-2xl">Guest list</h1>
        <p className="text-ink-soft mt-1 text-sm">Tom &amp; Jess &middot; admin</p>

        <form onSubmit={handleSubmit} className="mt-8" noValidate>
          <label htmlFor="admin-password" className="text-ink-soft block text-xs tracking-widest uppercase">
            Password
          </label>
          <input
            id="admin-password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={submitting}
            autoFocus
            autoComplete="current-password"
            aria-invalid={error !== null}
            aria-describedby={error ? 'admin-password-error' : undefined}
            className="border-ink/20 bg-parchment/60 focus:border-claret mt-2 w-full rounded-md border px-4 py-3 transition-colors disabled:opacity-60"
          />

          {error && (
            <p id="admin-password-error" role="alert" className="text-claret mt-3 text-sm">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={submitting || password === ''}
            className="bg-claret hover:bg-claret-dark mt-6 w-full rounded-md px-4 py-3 text-sm tracking-widest text-white uppercase transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            {submitting ? 'Checking…' : 'Sign in'}
          </button>
        </form>
      </div>
    </main>
  )
}
